<template>
<div class="row m-0 p-0">
	<station-report-form
		v-if="station !== undefined"
		class="col-12 g-0 half-transparent-border"
		style="display: block;"
		:userName="accountStore.userName"
		:stationId="station.id"
	/>
</div>

<div class="row m-0 p-0 mt-2">
	<!-- <h5>Стан запиту</h5> -->
	<rpc-table
		:stationId="stationId"
		:filterJobs="[rpcTaskSchema.job.allowed.buildStationReport.key]"
		:height="easyDataTableHeight() - 280"
	/>
</div>
</template>


<script>
import StationReportForm from './StationReportForm.vue'
import RpcTable from './RpcTable.vue'
import { useAccontStore } from '@/stores/AccountStore.js'
import { useStationsStore } from '@/stores/StationsStore'
import { rpcTaskSchema } from '@/composables/rpcTasks.js'
import {
	easyDataTableHeight,
} from '@/helpers.js'


export default {
	components: {
		StationReportForm,
		RpcTable,
	},

	props: {
		stationId: {
			type: String,
			require: true,
		},
	},

	setup() {
		const accountStore = useAccontStore()
		const stationsStore = useStationsStore()

		return {
			rpcTaskSchema,
			accountStore,
			stationsStore,
			easyDataTableHeight,
		}
	},

	data() {
		return {
			// For table period from. Hours from now.
			logDaysFromNow: 1,
		}
	},

	async created() {
	},

	methods: {
	},

	computed: {
		station() {return this.stationsStore.station(this.stationId); },
	},
}
</script>


<style src="../../assets/widget.css" scoped></style>
<style scoped>
</style>